module.exports = __webpack_public_path__ + "mobilecode.b176709a.png";